import type { Match, Team, Weights } from "./types";

export const eventSnapshot = {
  name: "The Injective Global Cup",
  window: "2026-07-03 to 2026-07-26",
  submission: "https://xsxo494365r.typeform.com/to/TMaGb1du",
  judgingFocus: [
    "World Cup utility",
    "clean GitHub repository",
    "clear README",
    "creative use of Injective x402, USDC CCTP, MCP Server, and Agent Skills",
  ],
};

export const defaultWeights: Weights = {
  form: 28,
  attack: 24,
  defense: 22,
  pressure: 16,
  travel: 10,
};

export const teams: Team[] = [
  {
    code: "ARG",
    name: "Argentina",
    group: "A",
    confederation: "CONMEBOL",
    fifaRank: 1,
    attack: 91,
    defense: 86,
    tempo: 78,
    setPieces: 80,
    depth: 84,
    homeTravel: 65,
    pressure: 92,
    fanMood: 88,
    note: "Best when the match becomes narrow, emotional, and decided by one late action.",
  },
  {
    code: "BRA",
    name: "Brazil",
    group: "C",
    confederation: "CONMEBOL",
    fifaRank: 5,
    attack: 94,
    defense: 83,
    tempo: 86,
    setPieces: 77,
    depth: 91,
    homeTravel: 70,
    pressure: 84,
    fanMood: 81,
    note: "Huge chance creation ceiling, with defensive spacing as the main swing factor.",
  },
  {
    code: "FRA",
    name: "France",
    group: "D",
    confederation: "UEFA",
    fifaRank: 2,
    attack: 93,
    defense: 87,
    tempo: 84,
    setPieces: 82,
    depth: 95,
    homeTravel: 59,
    pressure: 88,
    fanMood: 86,
    note: "Depth keeps the floor high across congested knockout schedules.",
  },
  {
    code: "ENG",
    name: "England",
    group: "E",
    confederation: "UEFA",
    fifaRank: 4,
    attack: 88,
    defense: 86,
    tempo: 76,
    setPieces: 88,
    depth: 90,
    homeTravel: 58,
    pressure: 80,
    fanMood: 76,
    note: "Set pieces and control are reliable; chance speed drops when trailing.",
  },
  {
    code: "ESP",
    name: "Spain",
    group: "B",
    confederation: "UEFA",
    fifaRank: 6,
    attack: 86,
    defense: 88,
    tempo: 90,
    setPieces: 74,
    depth: 87,
    homeTravel: 56,
    pressure: 83,
    fanMood: 84,
    note: "Controls field tilt and territory, but needs early final-third efficiency.",
  },
  {
    code: "GER",
    name: "Germany",
    group: "F",
    confederation: "UEFA",
    fifaRank: 10,
    attack: 86,
    defense: 80,
    tempo: 82,
    setPieces: 83,
    depth: 84,
    homeTravel: 57,
    pressure: 79,
    fanMood: 78,
    note: "Better when the game is open; risk appears in defensive rest positions.",
  },
  {
    code: "POR",
    name: "Portugal",
    group: "G",
    confederation: "UEFA",
    fifaRank: 7,
    attack: 89,
    defense: 82,
    tempo: 83,
    setPieces: 79,
    depth: 89,
    homeTravel: 58,
    pressure: 82,
    fanMood: 80,
    note: "A flexible creator pool makes bench timing very important.",
  },
  {
    code: "NED",
    name: "Netherlands",
    group: "H",
    confederation: "UEFA",
    fifaRank: 8,
    attack: 84,
    defense: 87,
    tempo: 80,
    setPieces: 85,
    depth: 82,
    homeTravel: 57,
    pressure: 81,
    fanMood: 79,
    note: "Back line security and aerial threat create a strong knockout profile.",
  },
  {
    code: "USA",
    name: "United States",
    group: "I",
    confederation: "CONCACAF",
    fifaRank: 11,
    attack: 82,
    defense: 78,
    tempo: 88,
    setPieces: 76,
    depth: 80,
    homeTravel: 97,
    pressure: 75,
    fanMood: 91,
    note: "Host energy and transition speed can tilt live momentum quickly.",
  },
  {
    code: "MEX",
    name: "Mexico",
    group: "A",
    confederation: "CONCACAF",
    fifaRank: 15,
    attack: 80,
    defense: 78,
    tempo: 82,
    setPieces: 79,
    depth: 77,
    homeTravel: 96,
    pressure: 77,
    fanMood: 93,
    note: "Home-field rhythm matters; the first 20 minutes often define match texture.",
  },
  {
    code: "JPN",
    name: "Japan",
    group: "J",
    confederation: "AFC",
    fifaRank: 17,
    attack: 81,
    defense: 80,
    tempo: 89,
    setPieces: 73,
    depth: 79,
    homeTravel: 51,
    pressure: 78,
    fanMood: 82,
    note: "High timing quality and counters make underdog games uncomfortable.",
  },
  {
    code: "MAR",
    name: "Morocco",
    group: "C",
    confederation: "CAF",
    fifaRank: 12,
    attack: 79,
    defense: 86,
    tempo: 78,
    setPieces: 80,
    depth: 78,
    homeTravel: 60,
    pressure: 85,
    fanMood: 87,
    note: "Compact shape and emotional control make them a hard knockout opponent.",
  },
  {
    code: "ECU",
    name: "Ecuador",
    group: "E",
    confederation: "CONMEBOL",
    fifaRank: 24,
    attack: 77,
    defense: 79,
    tempo: 82,
    setPieces: 75,
    depth: 74,
    homeTravel: 72,
    pressure: 76,
    fanMood: 78,
    note: "Direct transition threat and altitude-hardened stamina, but chance creation can dry up against deep blocks.",
  },
  {
    code: "CAN",
    name: "Canada",
    group: "B",
    confederation: "CONCACAF",
    fifaRank: 31,
    attack: 80,
    defense: 73,
    tempo: 88,
    setPieces: 72,
    depth: 76,
    homeTravel: 96,
    pressure: 73,
    fanMood: 90,
    note: "Host-region speed and vertical running can create strong knockout momentum.",
  },
  {
    code: "PAR",
    name: "Paraguay",
    group: "D",
    confederation: "CONMEBOL",
    fifaRank: 39,
    attack: 71,
    defense: 79,
    tempo: 70,
    setPieces: 82,
    depth: 72,
    homeTravel: 70,
    pressure: 80,
    fanMood: 74,
    note: "Low-block discipline and penalty resilience make them awkward in knockout football.",
  },
  {
    code: "BEL",
    name: "Belgium",
    group: "G",
    confederation: "UEFA",
    fifaRank: 9,
    attack: 87,
    defense: 80,
    tempo: 78,
    setPieces: 78,
    depth: 84,
    homeTravel: 57,
    pressure: 78,
    fanMood: 77,
    note: "Creator quality remains high, but defensive spacing determines their ceiling.",
  },
  {
    code: "NOR",
    name: "Norway",
    group: "I",
    confederation: "UEFA",
    fifaRank: 29,
    attack: 86,
    defense: 75,
    tempo: 80,
    setPieces: 84,
    depth: 74,
    homeTravel: 54,
    pressure: 74,
    fanMood: 83,
    note: "Elite box threat and set-piece danger make them volatile against possession teams.",
  },
  {
    code: "SUI",
    name: "Switzerland",
    group: "B",
    confederation: "UEFA",
    fifaRank: 18,
    attack: 78,
    defense: 82,
    tempo: 74,
    setPieces: 81,
    depth: 80,
    homeTravel: 58,
    pressure: 82,
    fanMood: 78,
    note: "Tournament floor is high due to compact defense and midfield control.",
  },
  {
    code: "COL",
    name: "Colombia",
    group: "K",
    confederation: "CONMEBOL",
    fifaRank: 14,
    attack: 84,
    defense: 80,
    tempo: 83,
    setPieces: 80,
    depth: 82,
    homeTravel: 73,
    pressure: 81,
    fanMood: 86,
    note: "In-form wide creation and duel power give them a dangerous knockout profile.",
  },
  {
    code: "EGY",
    name: "Egypt",
    group: "G",
    confederation: "CAF",
    fifaRank: 34,
    attack: 79,
    defense: 76,
    tempo: 76,
    setPieces: 77,
    depth: 72,
    homeTravel: 60,
    pressure: 78,
    fanMood: 82,
    note: "Counter-attacking star power can punish aggressive defensive lines.",
  },
];

export const matches: Match[] = [
  {
    id: "cup-001",
    round: "R16 · Match 95",
    venue: "Mercedes-Benz Stadium, Atlanta",
    kickoffLocal: "2026-07-07 12:00 UTC-4",
    home: "ARG",
    away: "EGY",
    status: "final",
    homeGoals: 3,
    awayGoals: 2,
    scoreLabel: "final",
    xgHome: 2.18,
    xgAway: 1.08,
    shotPressureHome: 68,
    shotPressureAway: 57,
    weather: "indoor",
    liveDataSource: "World Cup 2026 real result: Match 95, Argentina 3-2 Egypt, verified against worldcup26.ir and openfootball snapshots.",
  },
  {
    id: "cup-002",
    round: "QF · Match 100",
    venue: "GEHA Field at Arrowhead Stadium, Kansas City",
    kickoffLocal: "2026-07-11 20:00 UTC-5",
    home: "ARG",
    away: "SUI",
    status: "upcoming",
    xgHome: 1.58,
    xgAway: 0.94,
    shotPressureHome: 65,
    shotPressureAway: 49,
    weather: "dry",
    liveDataSource: "World Cup 2026 real schedule: Match 100, Argentina vs Switzerland, not started as of 2026-07-10.",
  },
  {
    id: "cup-003",
    round: "R16 · Match 93",
    venue: "AT&T Stadium, Dallas (Arlington)",
    kickoffLocal: "2026-07-06 14:00 UTC-5",
    home: "POR",
    away: "ESP",
    status: "upcoming",
    xgHome: 1.31,
    xgAway: 1.58,
    shotPressureHome: 61,
    shotPressureAway: 66,
    weather: "indoor",
    liveDataSource: "World Cup 2026 real schedule: Match 93, Portugal vs Spain.",
  },
  {
    id: "cup-004",
    round: "R16 · Match 94",
    venue: "Lumen Field, Seattle",
    kickoffLocal: "2026-07-06 17:00 UTC-7",
    home: "USA",
    away: "BEL",
    status: "upcoming",
    xgHome: 1.34,
    xgAway: 1.42,
    shotPressureHome: 63,
    shotPressureAway: 64,
    weather: "rain",
    liveDataSource: "World Cup 2026 real schedule: Match 94, United States vs Belgium.",
  },
];

export function teamByCode(code: Team["code"]): Team {
  const team = teams.find((candidate) => candidate.code === code);
  if (!team) throw new Error(`Unknown team code: ${code}`);
  return team;
}
